(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  class CollectionSubmenuBar {
    constructor() {
      this.submenuBar = document.querySelector('.collection-submenu-bar');
      this.menuItems = document.querySelectorAll('.header__menu-item[data-menu-parent]');
      this.currentActive = null;
      this.hideTimeout = null;
      
      if (this.submenuBar) {
        this.init();
      }
    }

    init() {
      // Add hover handlers to menu items
      this.menuItems.forEach(item => {
        const menuId = item.getAttribute('data-menu-parent');
        
        item.addEventListener('mouseenter', () => {
          clearTimeout(this.hideTimeout);
          this.showSubmenu(menuId, item);
        });

        item.addEventListener('mouseleave', () => {
          this.scheduleHide();
        });
      });

      // Keep submenu visible when hovering over it
      this.submenuBar.addEventListener('mouseenter', () => {
        clearTimeout(this.hideTimeout);
      });

      this.submenuBar.addEventListener('mouseleave', () => {
        this.scheduleHide();
      });

      // Setup scroll buttons
      this.setupScrollButtons();
    }

    showSubmenu(menuId, menuItem) {
      const submenu = document.querySelector(`[data-submenu-id="${menuId}"]`);
      
      if (!submenu) return;

      // Hide all submenus first
      document.querySelectorAll('.collection-submenu-content').forEach(s => {
        s.style.display = 'none';
      });

      // Remove active class from all menu items
      this.menuItems.forEach(item => {
        item.classList.remove('header__active-menu-item');
      });

      // Show the selected submenu
      submenu.style.display = 'block';
      this.submenuBar.classList.add('active');
      menuItem.classList.add('header__active-menu-item');
      this.currentActive = menuId;

      // Update scroll buttons
      setTimeout(() => this.updateScrollButtons(submenu), 10);
    }

    scheduleHide() {
      this.hideTimeout = setTimeout(() => {
        this.closeSubmenu();
      }, 300); // 300ms delay before hiding
    }

    closeSubmenu() {
      this.submenuBar.classList.remove('active');
      this.menuItems.forEach(item => {
        item.classList.remove('header__active-menu-item');
      });
      this.currentActive = null;
    }

    setupScrollButtons() {
      document.querySelectorAll('.submenu-scroll-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const wrapper = btn.parentElement.querySelector('.collection-submenu-wrapper');
          const scrollAmount = 300;
          
          if (btn.classList.contains('left')) {
            wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          } else {
            wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }

          setTimeout(() => this.updateScrollButtons(btn.closest('.collection-submenu-content')), 300);
        });
      });
    }

    updateScrollButtons(submenu) {
      const wrapper = submenu.querySelector('.collection-submenu-wrapper');
      const leftBtn = submenu.querySelector('.submenu-scroll-btn.left');
      const rightBtn = submenu.querySelector('.submenu-scroll-btn.right');

      if (!wrapper || !leftBtn || !rightBtn) return;

      // Check if scrollable
      const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
      
      if (!isScrollable) {
        leftBtn.classList.add('hidden');
        rightBtn.classList.add('hidden');
        return;
      }

      // Update button visibility based on scroll position
      leftBtn.classList.toggle('hidden', wrapper.scrollLeft <= 0);
      rightBtn.classList.toggle('hidden', 
        wrapper.scrollLeft >= wrapper.scrollWidth - wrapper.clientWidth - 1);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CollectionSubmenuBar();
    });
  } else {
    new CollectionSubmenuBar();
  }

    // Open plain dropdown menus (e.g. About Us) on hover
    document.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary || summary.hasAttribute('data-menu-parent')) return;

      let closeTimer;
      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        details.open = true;
      });
      menu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => { details.open = false; }, 200);
      });
    });


  } catch(e) { console.error(e); }
})();
})();
